import { node, icon } from "~/util/dom";
import { getDrawData } from "./provider";
import DrawTool from "./drawTool";
import { _ } from "~/i18n";
import Scene from "~/scene";

export default class ReportDefect {
	_dom: {[key: string]: HTMLElement};

	_active: boolean;

	_rid: string;

	_drawUtil: DrawTool;

	constructor() {
		this._dom = {
			cancelButton: node("button", { className: "reportDefect-cancelButton" }),
		};
		this._dom.cancelButton.append(
			icon("close"),
			node("span", { textContent: "Zrušit zobrazení problému" }),
		);
		this._dom.cancelButton.addEventListener("click", () => {
			this._cancelDraw();
		});
		this._active = false;
		this._rid = "";
	}

	/* eslint-disable class-methods-use-this */
	destroy() {
		//
	}

	isActive() {
		return this._active;
	}

	activate() {
		this._active = true;

		return this;
	}

	deactivate() {
		this._active = false;
		this._rid = "";

		return this;
	}

	getState() {
		return {};
	}

	setState(state: { [key: string]: any } = {}) {
		if (!("rid" in state)) {
			return;
		}

		this._rid = state.rid;
		this._loadDrawData();
	}

	async _loadDrawData() {
		try {
			const data = await getDrawData(this._rid);

			if (data.status >= 200 && data.status < 300 && data.report.scrawl.length) {
				this._showData(data);
			}
		} catch (exc) {
			/* eslint-disable no-console */
			console.log(exc);
			Mapy.getComponent("popup").createAlert(_("reportDefect.errorRead"));
		}
	}

	_showData(data: any) {
		this._drawUtil = new DrawTool(null, SMap.LAYER_TILE, () => { /**/ });
		this._drawUtil.enableLayer();
		this._drawUtil.drawFromCoords(data.report.scrawl);
		Scene.getContainer().append(this._dom.cancelButton);
	}

	_cancelDraw() {
		this._dom.cancelButton.remove();
		this._drawUtil.destroy();
		this._drawUtil = null;
	}
}
